<template>
  <div class="part2">
    <!-- <p class="threeGift"></p> -->
    <div class="partboxtwo">
      <div class="step1">
        <div class="step1_left">
          <!-- <img
            src="@/assets/images/page2/prize1.png"
            alt=""
            class="step1_left_img"
          /> -->
        </div>
        <div class="step1_right">
          <div class="step1_title">
            <img
              src="@/assets/images/page2/step1.png"
              alt=""
              class="step1_img"
            />
          </div>
          <div class="number mt">
            <select id="group" v-model="bookingData.area" :disabled="disable">
              <option value="886">台灣+886</option>
              <option value="852">香港+852</option>
              <option value="853">澳门+853</option>
            </select>
            <input
              type="text"
              class="colorinput"
              :placeholder="placeholdText"
              v-model="bookingData.mobile"
              :disabled="disable"
              :class="[isTrueMobile ? 'color-green' : 'color-red']"
            />
          </div>
          <p class="agree dl">
            <img
              src="@/assets/images/ischiose.png"
              alt=""
              @click="agree = !agree"
              v-if="agree"
              class="radio"
            />
            <img
              src="@/assets/images/nochiose.png"
              alt=""
              @click="agree = !agree"
              v-else
              class="radio"
            />
            同意個人資料蒐集使用及接收獎勵簡訊
          </p>
          <div
            class="Reservation_button mt"
            @click="bookingHandle"
            :class="{ disable: disable }"
          ></div>
        </div>
      </div>
      <div class="step2">
        <div class="step1_left">
          <!-- <img
            src="@/assets/images/page2/prize2.png"
            alt=""
            class="step1_left_img"
          /> -->
        </div>
        <div class="step2_right">
          <div class="step1_title step2_title">
            <img
              src="@/assets/images/page2/step2.png"
              alt=""
              class="step1_img"
            />
          </div>
          <p
            class="iosStore"
            @click="shopyy(pageInfo.appleStoreUrl)"
            v-if="ios == 'ios'"
          ></p>
          <p
            class="googleStore"
            @click="shopyy(pageInfo.googleStoreUrl)"
            v-else
          ></p>
        </div>
      </div>
      <div class="step3">
        <div class="step1_left">
          <!-- <img
            src="@/assets/images/page2/prize3.png"
            alt=""
            class="step1_left_img"
          /> -->
        </div>
        <div class="step3_right">
          <div class="step1_title step3_title">
            <img
              src="@/assets/images/page2/step3.png"
              alt=""
              class="step1_img"
            />
          </div>
          <div class="fbStore" style="position: absolute" @click="openfb">
            <!-- :class="fblikeClass" -->
            <!-- <a
              href="javascript:void(0);"
              style="
                display: inline-block;
                vertical-align: middle;
                width: 100%;
                height: 100%;
              "
              @click="fbLikeReq"
            >
              <div
                style="
                  position: relative;
                  display: block;
                  margin: 0 auto;
                  transform-origin: 50% 50%;
                  font-size: 0;
                "
                class="fb-like"
                :data-size="likeSize"
                data-href="https://www.facebook.com/XM.DXZ"
                data-send="true"
                data-share="false"
                :data-width="likeW"
                :style="{ transform: likeScale }"
                :data-layout="likeLayout"
                data-show-faces="false"
                data-font="arial"
              ></div>
            </a> -->
          </div>
        </div>
        <img
          src="@/assets/images/page2/step3btn.png"
          alt=""
          class="step3btn"
          @click="anchor(3)"
        />
        <img
          src="@/assets/images/page2/ckHand.png"
          alt=""
          class="step3hand"
          @click="anchor(3)"
        />
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import { subscribe, shopSubscribe, fblike } from "@/js/api.js";
export default {
  name: "pageTwo",
  props: ["pageInfo", "inviteMa", "allCode"],
  data() {
    return {
      likeLayout: "button",
      likeW: 200,
      likeH: 80,
      likeScale: "scale(2)",
      likeSize: "large",

      bookingData: {
        area: "886", //区号
        mobile: "", //手机号
        c: "", // 渠道
        f: "", // 邀请码
      },
      agree: true,
      disable: false,
      disabled: false,
      timer: null,
      code: "", //点赞礼包码
      ios: "", //设备系统判断
      // canFbLike: true,
      backNum: this.$util.getItem("backShowNum") || 0,
    };
  },
  computed: {
    // fblikeClass() {
    //   return this.canFbLike ? "fbStore" : "fbStore2";
    // },
    phoneNumCheck() {
      let area = this.bookingData.area;
      let phone = this.bookingData.mobile;
      if (area === "886") {
        //台湾
        return /^(0?9\d{8})$/.test(phone);
      } else if (area === "852") {
        // 香港
        return /(^\d{8})$/.test(phone);
      } else {
        //澳门
        return /^([6]\d{7})$/.test(phone);
      }
    },
    shareUrl() {
      return location.origin + location.pathname + "?f=" + this.code;
    },
    placeholdText() {
      let text = "";
      switch (this.bookingData.area) {
        case "886":
          text = "9xxxxxxxx（共9位）";
          break;
        case "852":
          text = "xxxxxxxx（共8位）";
          break;
        case "853":
          text = "6xxxxxxx（共8位）";
          break;
      }
      return text;
    },
    isTrueMobile() {
      let reg;
      switch (this.bookingData.area) {
        case "886":
          reg = new RegExp(/^9\d{8}$/);
          break;
        case "852":
          reg = new RegExp(/^\d{8}$/);
          break;
        case "853":
          reg = new RegExp(/^6\d{7}$/);
          break;
      }
      return reg.test(this.bookingData.mobile);
    },
  },
  created() {
    this.bookingData.c = this.$util.getChannel(this) || "";
    this.bookingData.f = this.inviteMa || "";
    let phoneData = this.$util.getToken();
    this.ios = this.$util.appSource();
    this.bookingData.mobile = phoneData ? "您已完成預約" : "";
    this.disable = phoneData ? true : false;
  },
  mounted() {
    console.error(this.fblike);
    this.$bus.$on("point1", () => {
      this.anchor(2);
    });
    this.$bus.$on("num2", (res) => {
      this.backNum = res;
    });
    this.$bus.$on("gofb", () => {
      // this.czan();
      // this.fbLikeReq();
      this.openfb();
    });
    this.$bus.$on("disableBtn", (res) => {
      this.bookingData.mobile = res;
      this.disable = true;
    });
    this.$nextTick(() => {
      this.$on("pagetwo", (res) => {
        // console.error(res.isFbLike);
        this.canFbLike = res.isFbLike != 1;
      });
    });
    if (this.disable) {
      document
        .getElementsByClassName("colorinput")[0]
        .classList.add("colortrue");
    }
    this.fbLikeInit();
  },
  methods: {
    openfb() {
      this.$xmlog.fbLike(() => {
        location.href = "https://www.facebook.com/XM.DXZ"
      });
    },
    fbLikeInit() {
      this.likeW = screen.width > 750 ? 200 : 10;
      this.likeLayout = screen.width > 750 ? "button" : "button";
      this.likeSize = screen.width > 750 ? "large" : "small";
      if (screen.width > 750) {
        // $(".ulis")[0].style.marginBottom = 0.4 + "rem";
        this.likeScale = "scale(2.7)";
      } else if (screen.width < 375) {
        this.likeScale = "scale(1.6)";
      } else {
        this.likeScale = "scale(2)";
      }

      setTimeout(() => {
        FB &&
          FB.Event.subscribe("edge.create", (d) => {
            console.error(d);
          });
      }, 50000);
    },
    // fbLikeReq() {
    //   console.log(2222);
    //   console.error("22");
    //   if (!this.canFbLike) return;
    //   let phoneData = this.$util.getToken();
    //   if (phoneData) {
    //     let data = this.$util.getToken().token;
    //     fblike(data).then((res) => {
    //       console.log(res, "facebook点赞");
    //       this.code = res.code;
    //       if (res.code === 1003) {
    //         this.canFbLike = false;
    //         // alert("您已經點過贊了！");
    //         this.$bus.$emit("tips", "您已經點過贊了!");
    //         return;
    //       } else {
    //         this.canFbLike = false;
    //         this.$xmlog.fbLike(() => {
    //           window.open("https://www.facebook.com/XM.DXZ");
    //         });
    //         // this.$bus.$emit("reGetMinfo", this.returnShareUrl());
    //       }
    //     });
    //   } else {
    //     // alert("請先預約");
    //     this.$bus.$emit("tips", "請先預約");
    //     return;
    //   }
    // },
    //facebook点赞
    // czan() {
    //   if (!this.canFbLike) {
    //     this.$xmlog.fbLike(() => {
    //       window.open("https://www.facebook.com/XM.DXZ");
    //     });
    //     return;
    //   }
    // },
    // returnShareUrl() {
    //   location.href =
    //     "http://www.facebook.com/sharer.php?u=" +
    //     encodeURIComponent(this.shareUrl);
    // },
    //定位
    anchor(index) {
      // let ele = document.getElementsByClassName("partboxtwo")[0];
      // ele.scrollIntoView({ behavior: "smooth", block: "center" });
      let ele;
      if (index == 2) {
        ele = document.getElementsByClassName("part2")[0];
        let eletop = ele.offsetTop;
        window.scrollTo({
          top: eletop,
          behavior: "smooth",
        });
      } else {
        ele = document.getElementsByClassName("partbox")[0];
        ele.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
    //请求 商店预约
    shopyy(value) {
      let phoneData = this.$util.getToken();
      if (phoneData) {
        let data = this.$util.getToken().token;
        shopSubscribe(data).then(() => {
          this.$xmlog.clickStore(() => {
            location.href = value;
            this.$util.setItem("backShow", true);
            this.$util.setItem("backShowNum", this.backNum + 1);
            this.$bus.$emit("num", this.backNum + 1);
          });
        });
      } else {
        this.$xmlog.clickStore(() => {
          location.href = value;
          this.$util.setItem("backShow", true);
          this.$util.setItem("backShowNum", this.backNum + 1);
          this.$bus.$emit("num", this.backNum + 1);
        });
        // this.$bus.$emit("tips", "請先預約");
      }
    },
    async bookingHandle() {
      // this.$bus.$emit("tips", "活動已結束，請到商店下載體驗");

      //设置防抖,防止多次点击
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.disable) {
          return;
        }
        if (!this.phoneNumCheck) {
          // alert("請輸入正確的手機門號");
          this.$bus.$emit("tips", "請輸入正確的手機門號");
          return;
        }
        if (!this.agree) {
          // alert("請同意協議");
          this.$bus.$emit("tips", "請同意協議");
          return;
        }

        let data = this.bookingData;
        // 请求 手机号预约
        subscribe(data).then((res) => {
          if (res.code === 1002) {
            alert(res.msg);
            // this.$bus.$emit("tips", res.msg);
            return;
          }
          this.disable = true;
          this.$util.setItem("dxzPhone", {
            mobile: data.mobile,
            area: data.area,
            giftCode: res.data.code,
            inviteCode: res.data.inviteCode,
            token: res.data.token,
          });
          this.$bus.$emit("reGetMinfo", true);
          this.$xmlog.register(
            null,
            "+" + this.bookingData.area + this.bookingData.mobile
          );
          this.bookingData.mobile = "您已完成預約";
          // this.$bus.$emit("people", res.people); //更新预约人数(pageFive.vue)
          // this.$bus.$emit("tips", null, "yyss");
          this.$bus.$emit("tips", "活動已結束，請到商店下載體驗");
          document
            .getElementsByClassName("colorinput")[0]
            .classList.add("colortrue");
          // alert("预约成功");
          console.error(data);
        });
      }, 200);
    },
  },
};
</script>

<style lang="less" scoped>
.mt {
  margin-bottom: 0.1rem;
}
.part2 {
  width: 100%;
  z-index: 9;
  margin-top: 2.8rem;

  .partboxtwo {
    height: 100%;
    background-image: url("@/assets/images/page2/pageTwobg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 1.1rem 0.5rem 0.4rem 0.5rem;
    .step1_title {
      width: 100%;
      height: 0.5rem;
      margin-bottom: 0.2rem;
      .step1_img {
        width: 100%;
        vertical-align: top;
      }
    }
    .step1 {
      display: flex;
      margin-top: 0.2rem;
      .step1_left {
        width: 3rem;
        height: 2.8rem;
        position: relative;
        background: url("../assets/images/page2/prize1.png") no-repeat;
        position: relative;
        background-size: 100% 100%;
        flex: 0 0 40%;
      }
      .step1_right {
        .number {
          display: flex;
          height: 0.6rem;
          padding: 0.1rem;
          background: url("@/assets/images/page2/inputbg.png") no-repeat;
          background-size: 100% 100%;
          select {
            border: none;
            background: transparent;
            color: #fff;
            font-size: 0.22rem;
            option {
              background: #7c7b7b;
            }
          }
          input {
            padding: 0;
            width: 100%;
            padding-left: 0.1rem;
            height: 0.54rem;
            border: none;
            height: 100%;
            border-left: 0.02px solid #fff;
            background: transparent;
            color: red;
            border-radius: 0;
            font-size: 0.22rem;
            &::placeholder {
              color: #fff;
            }
          }
          .color-green {
            color: green;
          }
          .color-red {
            color: red;
          }
          .colortrue {
            color: #cfcfcf;
          }
        }
        .Reservation_button {
          width: 3.94rem;
          height: 1rem;
          background: url("../assets/images/page2/order.png") no-repeat;
          background-position: center;
          background-size: 100% 100%;
          cursor: pointer;
          margin: 0 auto;
        }
        .disable {
          cursor: no-drop;
          filter: grayscale(100%);
        }
        .agree {
          font-size: 0.2rem;
          justify-content: start;
          position: relative;
          color: #052349;
          margin-bottom: 0.28rem;
          .radio {
            margin: 0;
            width: 0.3rem;
            height: 0.3rem;
            margin-right: 0.09rem;
          }
        }
      }
    }
    .step2 {
      display: flex;
      .step1_left {
        width: 3.2rem;
        height: 3rem;
        position: relative;
        top: 0.2rem;
        background: url("../assets/images/page2/prize2.png") no-repeat;
        position: relative;
        background-size: 100% 100%;
        flex: 0 0 40%;
      }
      .step2_left {
        width: 2rem;
        .step2_left_img {
          width: 100%;
        }
      }
      .step2_right {
        transform: translateY(0.41rem);
        .step2_title {
          margin-bottom: 0.3rem;
          width: 100%;
        }
        .iosStore {
          background: url("@/assets/images/page2/iosbtn2.png") no-repeat;
          background-size: 100% 100%;
          width: 2.74rem;
          margin: 0 auto;
          height: 0.8rem;
          cursor: pointer;
        }
        .googleStore {
          background: url("@/assets/images/page2/googlebtn2.png") no-repeat;
          background-size: 100% 100%;
          width: 2.74rem;
          margin: 0 auto;
          height: 0.8rem;
          cursor: pointer;
        }
      }
    }
    .step3 {
      display: flex;
      position: relative;
      .step1_left {
        width: 2.7rem;
        height: 2.3rem;
        top: 0rem;
        background: url("../assets/images/page2/prize3.png") no-repeat;
        position: relative;
        background-size: 100% 100%;
        flex: 0 0 42%;
      }
      .step3_right {
        transform: translateY(0.41rem);
        .step3_title {
          margin-bottom: 0.2rem;
          width: 75%;
        }
        .fbStore {
          background: url("@/assets/images/page2/fbzan2.png") no-repeat;
          background-size: contain;
          width: 2.84rem;
          text-align: center;
          height: 0.88rem;
          cursor: pointer;
          // font-size: 1.4rem;
        }

        .fbStore2 {
          width: 3.09rem;
          text-align: center;
          // background: url("@/assets/images/page2/fbzan2_s.png") no-repeat;
          background-size: contain;
          // width: 100%;
          height: 0.88rem;
          cursor: pointer;
        }
      }
      .step3btn {
        position: absolute;
        right: -0.2rem;
        bottom: -0.6rem;
        width: 1.5rem;
        height: 3rem;
        cursor: pointer;
      }
      .step3hand {
        animation: scale 1.5s infinite;
        position: absolute;
        right: -0.2rem;
        bottom: -0.01rem;
        width: 0.7rem;
        cursor: pointer;
      }
      // .re_song {
      //   justify-content: center;
      //   font-size: 0.3rem;
      //   .pri_open {
      //     width: 2.5rem;
      //     height: 1.5rem;
      //     line-height: 1.5rem;
      //     margin-right: 0.6rem;
      //     border: 1px solid #000;
      //   }
      //   .shopbtn {
      //     width: 2.5rem;
      //     height: 1rem;
      //     line-height: 1rem;
      //     border: 1px solid #000;
      //     cursor: pointer;
      //   }
      // }
    }
  }
}
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>